import { render } from "./CatGrupoMaterialView.vue?vue&type=template&id=4909d9ab&scoped=true"
import script from "./CatGrupoMaterialView.vue?vue&type=script&lang=js"
export * from "./CatGrupoMaterialView.vue?vue&type=script&lang=js"

import "./CatGrupoMaterialView.vue?vue&type=style&index=0&id=4909d9ab&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4909d9ab"]])

export default __exports__